import {GenerationStatusEnum} from "./shared/types/GenerationStatusEnum.ts";
import {GenerationType, TGeneration} from "./shared/types/GenerationType.ts";

const demoVideoUrl = "https://cdn.algorana.dev/6f3a81adef966eb99f64753f874f720d";

const completedVideo = (id: number, url: string, type: GenerationType = "video"): TGeneration => ({
  id,
  status: GenerationStatusEnum.GENERATED,
  resultSrc: url,
  previewSrc: url,
  type,
});

export const mockGenerations: TGeneration[] = [
  completedVideo(75, demoVideoUrl),
  completedVideo(74, demoVideoUrl),
  completedVideo(72, demoVideoUrl),
  completedVideo(71, demoVideoUrl),
  completedVideo(70, demoVideoUrl),
  completedVideo(62, demoVideoUrl),
  completedVideo(61, "https://cdn.algorana.dev/86b259491a3a79710d4b706383a6a663"),
  completedVideo(50, demoVideoUrl),
  completedVideo(49, demoVideoUrl),
  completedVideo(48, demoVideoUrl),
  completedVideo(47, demoVideoUrl),
  completedVideo(46, demoVideoUrl),
  completedVideo(42, demoVideoUrl),
  completedVideo(41, demoVideoUrl),
  completedVideo(40, demoVideoUrl),
  completedVideo(39, demoVideoUrl),
  completedVideo(38, demoVideoUrl),
  completedVideo(37, demoVideoUrl),
  completedVideo(36, demoVideoUrl),
  completedVideo(35, demoVideoUrl),
  completedVideo(34, demoVideoUrl),
  completedVideo(33, demoVideoUrl),
  completedVideo(32, demoVideoUrl),
];
